/** @jsxImportSource @emotion/react */


import { Fragment, memo, useContext, useEffect, useState } from "react"
import { Event, getBackendURL, isBackendDisabled, isTrue, refs } from "$/utils/state"
import { Box as RadixThemesBox, Code as RadixThemesCode, Flex as RadixThemesFlex, Heading as RadixThemesHeading, Link as RadixThemesLink, Text as RadixThemesText } from "@radix-ui/themes"
import { Code as ShikiCode } from "$/components/shiki/code"
import { ColorModeContext, EventLoopContext } from "$/utils/context"
import { Copy as LucideCopy, Link as LucideLink, WifiOff as LucideWifiOff } from "lucide-react"
import NextLink from "next/link"
import ReactMarkdown from "react-markdown"
import "katex/dist/katex.min.css"
import remarkMath from "remark-math"
import remarkGfm from "remark-gfm"
import remarkUnwrapImages from "remark-unwrap-images"
import rehypeKatex from "rehype-katex"
import rehypeRaw from "rehype-raw"
import { PrismAsyncLight as SyntaxHighlighter } from "react-syntax-highlighter"
import oneLight from "react-syntax-highlighter/dist/cjs/styles/prism/one-light"
import oneDark from "react-syntax-highlighter/dist/cjs/styles/prism/one-dark"
import { toast, Toaster } from "sonner"
import { jsx, keyframes } from "@emotion/react"
import env from "$/env.json"



        function ComponentMap_85c510a48f6f69884e0c37924bfe5c25 () {
            
  const { resolvedColorMode } = useContext(ColorModeContext)

  
if ("python") {
    
(async () => {
    try {
        const module = await import(`react-syntax-highlighter/dist/cjs/languages/prism/${"python"}`);
        SyntaxHighlighter.registerLanguage("python", module.default);
    } catch (error) {
        console.error(`Language ${"python"} is not supported for code blocks inside of markdown: `, error);
    }
})();

}


            return (
                ({ ["h1"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h1",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"6",...props},children,))), ["h2"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h2",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"5",...props},children,))), ["h3"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h3",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"4",...props},children,))), ["h4"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h4",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"3",...props},children,))), ["h5"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h5",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"2",...props},children,))), ["h6"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h6",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"1",...props},children,))), ["p"] : (({node, children, ...props}) => (jsx(RadixThemesText,{as:"p",css:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),...props},children,))), ["ul"] : (({node, children, ...props}) => (jsx("ul",{css:({ ["listStyleType"] : "disc", ["marginTop"] : "1em", ["marginBottom"] : "1em", ["marginLeft"] : "1.5rem", ["direction"] : "column" })},children,))), ["ol"] : (({node, children, ...props}) => (jsx("ol",{css:({ ["listStyleType"] : "decimal", ["marginTop"] : "1em", ["marginBottom"] : "1em", ["marginLeft"] : "1.5rem", ["direction"] : "column" })},children,))), ["li"] : (({node, children, ...props}) => (jsx("li",{css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" })},children,))), ["a"] : (({node, children, ...props}) => (jsx(RadixThemesLink,{css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),href:"#",...props},children,))), ["code"] : (({node, inline, className, children, ...props}) => { const match = (className || '').match(/language-(?<lang>.*)/); let _language = match ? match[1] : '';   if (_language) {     if (!["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apex", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "asmatmel", "aspnet", "autohotkey", "autoit", "avisynth", "avro-idl", "bash", "basic", "batch", "bbcode", "bicep", "birb", "bison", "bnf", "brainfuck", "brightscript", "bro", "bsl", "c", "cfscript", "chaiscript", "cil", "clike", "clojure", "cmake", "cobol", "coffeescript", "concurnas", "coq", "core", "cpp", "crystal", "csharp", "cshtml", "csp", "css", "css-extras", "csv", "cypher", "d", "dart", "dataweave", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "dot", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "false", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gap", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "gn", "go", "go-module", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hoon", "hpkp", "hsts", "http", "ichigojam", "icon", "icu-message-format", "idris", "iecst", "ignore", "index", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jexl", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keepalived", "keyman", "kotlin", "kumir", "kusto", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "log", "lolcode", "lua", "magma", "makefile", "markdown", "markup", "markup-templating", "matlab", "maxscript", "mel", "mermaid", "mizar", "mongodb", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "naniscript", "nasm", "neon", "nevod", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "openqasm", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php", "php-extras", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "promql", "properties", "protobuf", "psl", "pug", "puppet", "pure", "purebasic", "purescript", "python", "q", "qml", "qore", "qsharp", "r", "racket", "reason", "regex", "rego", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "sml", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "squirrel", "stan", "stylus", "swift", "systemd", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tremor", "tsx", "tt2", "turtle", "twig", "typescript", "typoscript", "unrealscript", "uorazor", "uri", "v", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "web-idl", "wiki", "wolfram", "wren", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"].includes(_language)) {         console.warn(`Language \`${_language}\` is not supported for code blocks inside of markdown.`);         _language = '';     } else {          (async () => {     try {         const module = await import(`react-syntax-highlighter/dist/cjs/languages/prism/${_language}`);         SyntaxHighlighter.registerLanguage(_language, module.default);     } catch (error) {         console.error(`Language ${_language} is not supported for code blocks inside of markdown: `, error);     } })();      }   }  ;             return inline ? (                 jsx(RadixThemesCode,{...props},children,)             ) : (                 jsx(SyntaxHighlighter,{children:((Array.isArray(children)) ? children.join("\n") : children),css:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),customStyle:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),language:_language,style:((resolvedColorMode === "light") ? oneLight : oneDark),wrapLongLines:true,...props},)             );         }) })
            )
        }
        

        function ComponentMap_db87c791c5449d72e8c60c9583808f71 () {
            
  const { resolvedColorMode } = useContext(ColorModeContext)

  
if ("python") {
    
(async () => {
    try {
        const module = await import(`react-syntax-highlighter/dist/cjs/languages/prism/${"python"}`);
        SyntaxHighlighter.registerLanguage("python", module.default);
    } catch (error) {
        console.error(`Language ${"python"} is not supported for code blocks inside of markdown: `, error);
    }
})();

}


            return (
                ({ ["h1"] : (({node, children, ...props}) => (jsx(H1Comp,{text:children,...props},))), ["h2"] : (({node, children, ...props}) => (jsx(H2Comp,{text:children,...props},))), ["h3"] : (({node, children, ...props}) => (jsx(H3Comp,{text:children,...props},))), ["h4"] : (({node, children, ...props}) => (jsx(H4Comp,{text:children,...props},))), ["h5"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h5",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"2",...props},children,))), ["h6"] : (({node, children, ...props}) => (jsx(RadixThemesHeading,{as:"h6",css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" }),size:"1",...props},children,))), ["p"] : (({node, children, ...props}) => (jsx(RadixThemesText,{as:"p",css:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),...props},children,))), ["ul"] : (({node, children, ...props}) => (jsx("ul",{css:({ ["listStyleType"] : "disc", ["marginTop"] : "1em", ["marginBottom"] : "1em", ["marginLeft"] : "1.5rem", ["direction"] : "column" })},children,))), ["ol"] : (({node, children, ...props}) => (jsx("ol",{css:({ ["listStyleType"] : "decimal", ["marginTop"] : "1em", ["marginBottom"] : "1em", ["marginLeft"] : "1.5rem", ["direction"] : "column" })},children,))), ["li"] : (({node, children, ...props}) => (jsx("li",{css:({ ["marginTop"] : "0.5em", ["marginBottom"] : "0.5em" })},children,))), ["a"] : (({node, children, ...props}) => (jsx(RadixThemesLink,{css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),href:"#",...props},children,))), ["code"] : (({node, inline, className, children, ...props}) => { const match = (className || '').match(/language-(?<lang>.*)/); let _language = match ? match[1] : '';   if (_language) {     if (!["abap", "abnf", "actionscript", "ada", "agda", "al", "antlr4", "apacheconf", "apex", "apl", "applescript", "aql", "arduino", "arff", "asciidoc", "asm6502", "asmatmel", "aspnet", "autohotkey", "autoit", "avisynth", "avro-idl", "bash", "basic", "batch", "bbcode", "bicep", "birb", "bison", "bnf", "brainfuck", "brightscript", "bro", "bsl", "c", "cfscript", "chaiscript", "cil", "clike", "clojure", "cmake", "cobol", "coffeescript", "concurnas", "coq", "core", "cpp", "crystal", "csharp", "cshtml", "csp", "css", "css-extras", "csv", "cypher", "d", "dart", "dataweave", "dax", "dhall", "diff", "django", "dns-zone-file", "docker", "dot", "ebnf", "editorconfig", "eiffel", "ejs", "elixir", "elm", "erb", "erlang", "etlua", "excel-formula", "factor", "false", "firestore-security-rules", "flow", "fortran", "fsharp", "ftl", "gap", "gcode", "gdscript", "gedcom", "gherkin", "git", "glsl", "gml", "gn", "go", "go-module", "graphql", "groovy", "haml", "handlebars", "haskell", "haxe", "hcl", "hlsl", "hoon", "hpkp", "hsts", "http", "ichigojam", "icon", "icu-message-format", "idris", "iecst", "ignore", "index", "inform7", "ini", "io", "j", "java", "javadoc", "javadoclike", "javascript", "javastacktrace", "jexl", "jolie", "jq", "js-extras", "js-templates", "jsdoc", "json", "json5", "jsonp", "jsstacktrace", "jsx", "julia", "keepalived", "keyman", "kotlin", "kumir", "kusto", "latex", "latte", "less", "lilypond", "liquid", "lisp", "livescript", "llvm", "log", "lolcode", "lua", "magma", "makefile", "markdown", "markup", "markup-templating", "matlab", "maxscript", "mel", "mermaid", "mizar", "mongodb", "monkey", "moonscript", "n1ql", "n4js", "nand2tetris-hdl", "naniscript", "nasm", "neon", "nevod", "nginx", "nim", "nix", "nsis", "objectivec", "ocaml", "opencl", "openqasm", "oz", "parigp", "parser", "pascal", "pascaligo", "pcaxis", "peoplecode", "perl", "php", "php-extras", "phpdoc", "plsql", "powerquery", "powershell", "processing", "prolog", "promql", "properties", "protobuf", "psl", "pug", "puppet", "pure", "purebasic", "purescript", "python", "q", "qml", "qore", "qsharp", "r", "racket", "reason", "regex", "rego", "renpy", "rest", "rip", "roboconf", "robotframework", "ruby", "rust", "sas", "sass", "scala", "scheme", "scss", "shell-session", "smali", "smalltalk", "smarty", "sml", "solidity", "solution-file", "soy", "sparql", "splunk-spl", "sqf", "sql", "squirrel", "stan", "stylus", "swift", "systemd", "t4-cs", "t4-templating", "t4-vb", "tap", "tcl", "textile", "toml", "tremor", "tsx", "tt2", "turtle", "twig", "typescript", "typoscript", "unrealscript", "uorazor", "uri", "v", "vala", "vbnet", "velocity", "verilog", "vhdl", "vim", "visual-basic", "warpscript", "wasm", "web-idl", "wiki", "wolfram", "wren", "xeora", "xml-doc", "xojo", "xquery", "yaml", "yang", "zig"].includes(_language)) {         console.warn(`Language \`${_language}\` is not supported for code blocks inside of markdown.`);         _language = '';     } else {          (async () => {     try {         const module = await import(`react-syntax-highlighter/dist/cjs/languages/prism/${_language}`);         SyntaxHighlighter.registerLanguage(_language, module.default);     } catch (error) {         console.error(`Language ${_language} is not supported for code blocks inside of markdown: `, error);     } })();      }   }  ;             return inline ? (                 jsx(RadixThemesCode,{...props},children,)             ) : (                 jsx(SyntaxHighlighter,{children:((Array.isArray(children)) ? children.join("\n") : children),css:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),customStyle:({ ["marginTop"] : "1em", ["marginBottom"] : "1em" }),language:_language,style:((resolvedColorMode === "light") ? oneLight : oneDark),wrapLongLines:true,...props},)             );         }) })
            )
        }
        

const pulse = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`



export const CodeBlock = memo(({code, language}) => {
    
  const { resolvedColorMode } = useContext(ColorModeContext)
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesBox,
{className:"relative mb-4"},
jsx(
RadixThemesBox,
{className:"code-block",css:({ ["pre"] : ({ ["margin"] : "0", ["padding"] : "24px", ["background"] : "transparent", ["overflowX"] : "auto", ["borderRadius"] : "6px" }), ["position"] : "relative" })},
jsx(ShikiCode,{code:code,decorations:[],language:language,theme:((resolvedColorMode === "light") ? "one-light" : "one-dark-pro"),transformers:[]},)
,jsx(
"button",
{css:({ ["position"] : "absolute", ["top"] : "4px", ["right"] : "4px", ["background"] : "var(--gray-3)", ["border"] : "1px solid", ["borderColor"] : "var(--gray-5)", ["borderRadius"] : "6px", ["padding"] : "5px", ["opacity"] : "1", ["cursor"] : "pointer", ["&:hover"] : ({ ["background"] : "var(--gray-4)" }), ["transition"] : "background 0.250s ease-out", ["&>svg"] : ({ ["transition"] : "transform 0.250s ease-out, opacity 0.250s ease-out" }), ["&:active"] : ({ ["background"] : "var(--gray-5)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](code.replaceAll(/[\/#]+ *\[!code.*?\]/g, "")))), ["callback"] : null }), ({  }))), (Event("_call_function", ({ ["function"] : (() => 
// Event listener for the parent click
document.addEventListener('click', function(event) {
    // Find the closest button (parent element)
    const parent = event.target.closest('button');
    // If the parent is found
    if (parent) {
        // Find the SVG element within the parent
        const svgIcon = parent.querySelector('svg');
        // If the SVG exists, proceed with the script
        if (svgIcon) {
            const originalPath = svgIcon.innerHTML;
            const checkmarkPath = '<polyline points="20 6 9 17 4 12"></polyline>';  // Checkmark SVG path
            function transition(element, scale, opacity) {
                element.style.transform = `scale(${scale})`;
                element.style.opacity = opacity;
            }
            // Animate the SVG
            transition(svgIcon, 0, '0');
            setTimeout(() => {
                svgIcon.innerHTML = checkmarkPath;  // Replace content with checkmark
                svgIcon.setAttribute('viewBox', '0 0 24 24');  // Adjust viewBox if necessary
                transition(svgIcon, 1, '1');
                setTimeout(() => {
                    transition(svgIcon, 0, '0');
                    setTimeout(() => {
                        svgIcon.innerHTML = originalPath;  // Restore original SVG content
                        transition(svgIcon, 1, '1');
                    }, 125);
                }, 600);
            }, 125);
        } else {
            // console.error('SVG element not found within the parent.');
        }
    } else {
        // console.error('Parent element not found.');
    }
})
), ["callback"] : null }), ({  })))], args, ({  }))))},
jsx(LucideCopy,{css:({ ["color"] : "var(--gray-11)" }),size:16},)
,),),)
      )

})

export const CodeBlockDark = memo(({code, language}) => {
    
  const { resolvedColorMode } = useContext(ColorModeContext)
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesBox,
{className:"relative"},
jsx(
RadixThemesBox,
{className:"code-block",css:({ ["pre"] : ({ ["margin"] : "0", ["padding"] : "24px", ["background"] : "transparent", ["overflowX"] : "auto", ["borderRadius"] : "6px" }), ["position"] : "relative" })},
jsx(ShikiCode,{code:code,decorations:[],language:language,theme:((resolvedColorMode === "light") ? "one-light" : "one-dark-pro"),transformers:[]},)
,jsx(
"button",
{css:({ ["position"] : "absolute", ["top"] : "4px", ["right"] : "4px", ["background"] : "var(--gray-3)", ["border"] : "1px solid", ["borderColor"] : "var(--gray-5)", ["borderRadius"] : "6px", ["padding"] : "5px", ["opacity"] : "1", ["cursor"] : "pointer", ["&:hover"] : ({ ["background"] : "var(--gray-4)" }), ["transition"] : "background 0.250s ease-out", ["&>svg"] : ({ ["transition"] : "transform 0.250s ease-out, opacity 0.250s ease-out" }), ["&:active"] : ({ ["background"] : "var(--gray-5)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](code.replaceAll(/[\/#]+ *\[!code.*?\]/g, "")))), ["callback"] : null }), ({  }))), (Event("_call_function", ({ ["function"] : (() => 
// Event listener for the parent click
document.addEventListener('click', function(event) {
    // Find the closest button (parent element)
    const parent = event.target.closest('button');
    // If the parent is found
    if (parent) {
        // Find the SVG element within the parent
        const svgIcon = parent.querySelector('svg');
        // If the SVG exists, proceed with the script
        if (svgIcon) {
            const originalPath = svgIcon.innerHTML;
            const checkmarkPath = '<polyline points="20 6 9 17 4 12"></polyline>';  // Checkmark SVG path
            function transition(element, scale, opacity) {
                element.style.transform = `scale(${scale})`;
                element.style.opacity = opacity;
            }
            // Animate the SVG
            transition(svgIcon, 0, '0');
            setTimeout(() => {
                svgIcon.innerHTML = checkmarkPath;  // Replace content with checkmark
                svgIcon.setAttribute('viewBox', '0 0 24 24');  // Adjust viewBox if necessary
                transition(svgIcon, 1, '1');
                setTimeout(() => {
                    transition(svgIcon, 0, '0');
                    setTimeout(() => {
                        svgIcon.innerHTML = originalPath;  // Restore original SVG content
                        transition(svgIcon, 1, '1');
                    }, 125);
                }, 600);
            }, 125);
        } else {
            // console.error('SVG element not found within the parent.');
        }
    } else {
        // console.error('Parent element not found.');
    }
})
), ["callback"] : null }), ({  })))], args, ({  }))))},
jsx(LucideCopy,{css:({ ["color"] : "var(--gray-11)" }),size:16},)
,),),)
      )

})

export const H1Comp = memo(({text}) => {
    
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesLink,
{asChild:true,className:"flex flex-row items-center gap-6 hover:!text-violet-11 text-slate-12 cursor-pointer mb-2 transition-colors group",css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](("#"+text.at(0).toLowerCase().split(" ").join("-"))))), ["callback"] : null }), ({  })))], args, ({  })))),underline:"none"},
jsx(
NextLink,
{href:("#"+text.at(0).toLowerCase().split(" ").join("-")),passHref:true},
jsx(
RadixThemesHeading,
{as:"h1",className:"font-x-large lg:font-xx-large scroll-m-[5rem] mt-4",id:text.at(0).toLowerCase().split(" ").join("-")},
text.at(0)
,),jsx(LucideLink,{className:"!text-violet-11 invisible transition-[visibility_0.075s_ease-out] group-hover:visible mt-4",size:18},)
,),)
      )

})

export const H2Comp = memo(({text}) => {
    
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesLink,
{asChild:true,className:"flex flex-row items-center gap-6 hover:!text-violet-11 text-slate-12 cursor-pointer mb-2 transition-colors group",css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](("#"+text.at(0).toLowerCase().split(" ").join("-"))))), ["callback"] : null }), ({  })))], args, ({  })))),underline:"none"},
jsx(
NextLink,
{href:("#"+text.at(0).toLowerCase().split(" ").join("-")),passHref:true},
jsx(
RadixThemesHeading,
{as:"h2",className:"font-large lg:font-x-large scroll-m-[5rem] mt-8",id:text.at(0).toLowerCase().split(" ").join("-")},
text.at(0)
,),jsx(LucideLink,{className:"!text-violet-11 invisible transition-[visibility_0.075s_ease-out] group-hover:visible mt-8",size:18},)
,),)
      )

})

export const H3Comp = memo(({text}) => {
    
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesLink,
{asChild:true,className:"flex flex-row items-center gap-6 hover:!text-violet-11 text-slate-12 cursor-pointer mb-2 transition-colors group",css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](("#"+text.at(0).toLowerCase().split(" ").join("-"))))), ["callback"] : null }), ({  })))], args, ({  })))),underline:"none"},
jsx(
NextLink,
{href:("#"+text.at(0).toLowerCase().split(" ").join("-")),passHref:true},
jsx(
RadixThemesHeading,
{as:"h3",className:"font-large scroll-m-[5rem] mt-4",id:text.at(0).toLowerCase().split(" ").join("-")},
text.at(0)
,),jsx(LucideLink,{className:"!text-violet-11 invisible transition-[visibility_0.075s_ease-out] group-hover:visible mt-4",size:18},)
,),)
      )

})

export const H4Comp = memo(({text}) => {
    
  const [addEvents, connectErrors] = useContext(EventLoopContext);




    return(
        jsx(
RadixThemesLink,
{asChild:true,className:"flex flex-row items-center gap-6 hover:!text-violet-11 text-slate-12 cursor-pointer mb-2 transition-colors group",css:({ ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),onClick:((...args) => (addEvents([(Event("_call_function", ({ ["function"] : (() => (navigator["clipboard"]["writeText"](("#"+text.at(0).toLowerCase().split(" ").join("-"))))), ["callback"] : null }), ({  })))], args, ({  })))),underline:"none"},
jsx(
NextLink,
{href:("#"+text.at(0).toLowerCase().split(" ").join("-")),passHref:true},
jsx(
RadixThemesHeading,
{as:"h4",className:"font-md-smbold scroll-m-[5rem] mt-2",id:text.at(0).toLowerCase().split(" ").join("-")},
text.at(0)
,),jsx(LucideLink,{className:"!text-violet-11 invisible transition-[visibility_0.075s_ease-out] group-hover:visible mt-2",size:18},)
,),)
      )

})

export const FlexdownMemo38296 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const MemoizedBadge = memo(({}) => {
    
  const { resolvedColorMode } = useContext(ColorModeContext)




    return(
        jsx(
"a",
{css:({ ["position"] : "fixed", ["bottom"] : "1rem", ["right"] : "1rem", ["display"] : "flex", ["flexDirection"] : "row", ["gap"] : "0.375rem", ["alignItems"] : "center", ["width"] : "auto", ["borderRadius"] : "0.5rem", ["color"] : ((resolvedColorMode === "light") ? "#E5E7EB" : "#27282B"), ["border"] : ((resolvedColorMode === "light") ? "1px solid #27282B" : "1px solid #E5E7EB"), ["backgroundColor"] : ((resolvedColorMode === "light") ? "#151618" : "#FCFCFD"), ["padding"] : "0.375rem", ["transition"] : "background-color 0.2s ease-in-out", ["boxShadow"] : "0 1px 2px 0 rgba(0, 0, 0, 0.05)", ["zIndex"] : "9998", ["cursor"] : "pointer", ["align"] : "center", ["textAlign"] : "center" }),href:"https://reflex.dev",target:"_blank"},
jsx(
"svg",
{css:({ ["fill"] : "white", ["viewBox"] : "0 0 16 16" }),height:"16",width:"16",xmlns:"http://www.w3.org/2000/svg"},
jsx("rect",{css:({ ["fill"] : "#6E56CF" }),height:"16",rx:"2",width:"16"},)
,jsx("path",{css:({ ["fill"] : "white" }),d:"M10 9V13H12V9H10Z"},)
,jsx("path",{css:({ ["fill"] : "white" }),d:"M4 3V13H6V9H10V7H6V5H10V7H12V3H4Z"},)
,),jsx(
RadixThemesBox,
{css:({ ["@media screen and (min-width: 0)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 30em)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 48em)"] : ({ ["display"] : "none" }), ["@media screen and (min-width: 62em)"] : ({ ["display"] : "block" }) })},
jsx(
RadixThemesText,
{as:"p",css:({ ["color"] : "var(--slate-1)", ["fontWeight"] : "600", ["fontFamily"] : "'Instrument Sans', sans-serif", ["--default-font-family"] : "'Instrument Sans', sans-serif", ["fontSize"] : "0.875rem", ["lineHeight"] : "1rem", ["letterSpacing"] : "-0.00656rem" })},
"Built with Reflex"
,),),)
      )

})

export const FlexdownMemo84108 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_db87c791c5449d72e8c60c9583808f71(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo77397 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo4268 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo42221 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo50933 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo77016 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo26748 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo13263 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo93367 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo71985 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo59870 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo65334 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo15521 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo64511 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo45812 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo18537 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo69791 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo97247 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo83229 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo46308 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo61226 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo81653 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo31546 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo26567 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo14119 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo65089 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo73971 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo29057 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo55500 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const FlexdownMemo25596 = memo(({content}) => {
    




    return(
        jsx(
ReactMarkdown,
{components:ComponentMap_85c510a48f6f69884e0c37924bfe5c25(),rehypePlugins:[rehypeKatex, rehypeRaw],remarkPlugins:[remarkMath, remarkGfm, remarkUnwrapImages]},
content
,)
      )

})

export const MemoizedToastProvider = memo(({}) => {
    
  const { resolvedColorMode } = useContext(ColorModeContext)

  refs['__toast'] = toast



    return(
        jsx(Toaster,{closeButton:false,expand:true,position:"bottom-right",richColors:true,theme:resolvedColorMode},)

      )

})

export const DefaultOverlayComponents = memo(({}) => {
    
  const [backendDisabled, setBackendDisabled] = useState(false);
  useEffect(() => { setBackendDisabled(isBackendDisabled()); }, []);

  const [addEvents, connectErrors] = useContext(EventLoopContext);
  const toast = refs['__toast'];
  const toast_props = ({ ["description"] : ("Check if server is reachable at "+getBackendURL(env.EVENT).href), ["closeButton"] : true, ["duration"] : 120000, ["id"] : "websocket-error" });
  const [userDismissed, setUserDismissed] = useState(false);
  const [waitedForBackend, setWaitedForBackend] = useState(false);
  (useEffect(
() => {
    if ((connectErrors.length >= 2)) {
        if (!userDismissed) {
            toast?.error(("Cannot connect to server: "+((connectErrors.length > 0) ? connectErrors[connectErrors.length - 1].message : '')+"."), {...toast_props, onDismiss: () => setUserDismissed(true)},)
        }
    } else {
        toast?.dismiss("websocket-error");
        setUserDismissed(false);  // after reconnection reset dismissed state
    }
}
, [connectErrors, waitedForBackend]))



    return(
        jsx(
Fragment,
{},
jsx(
"div",
{css:({ ["position"] : "fixed", ["width"] : "100vw", ["height"] : "0" }),title:("Connection Error: "+((connectErrors.length > 0) ? connectErrors[connectErrors.length - 1].message : ''))},
jsx(
Fragment,
{},
((connectErrors.length > 0) ? (jsx(
Fragment,
{},
jsx(LucideWifiOff,{css:({ ["color"] : "crimson", ["zIndex"] : 9999, ["position"] : "fixed", ["bottom"] : "33px", ["right"] : "33px", ["animation"] : (pulse+" 1s infinite") }),size:32},)
,)) : (jsx(Fragment,{},)
)),),),jsx(Fragment,{},)
,jsx(
"div",
{},
jsx(
Fragment,
{},
(isTrue(backendDisabled) ? (jsx(
Fragment,
{},
jsx(
RadixThemesBox,
{css:({ ["position"] : "fixed", ["zIndex"] : 9999, ["backdropFilter"] : "grayscale(1) blur(5px)", ["width"] : "100dvw", ["height"] : "100dvh" })},
jsx("link",{href:"https://fonts.googleapis.com",rel:"preconnect"},)
,jsx("link",{css:({ ["crossorigin"] : "" }),href:"https://fonts.gstatic.com",rel:"preconnect"},)
,jsx("link",{href:"https://fonts.googleapis.com/css2?family=Instrument+Sans:ital,wght@0,500;0,600&display=swap",rel:"stylesheet"},)
,jsx(
RadixThemesBox,
{css:({ ["fontFamily"] : "\"Instrument Sans\", \"Helvetica\", \"Arial\", sans-serif", ["--default-font-family"] : "\"Instrument Sans\", \"Helvetica\", \"Arial\", sans-serif", ["position"] : "fixed", ["top"] : "50%", ["left"] : "50%", ["transform"] : "translate(-50%, -50%)", ["width"] : "60ch", ["maxWidth"] : "90vw", ["borderRadius"] : "0.75rem", ["borderWidth"] : "1px", ["borderColor"] : "var(--slate-4)", ["padding"] : "1.5rem", ["backgroundColor"] : "var(--slate-1)", ["boxShadow"] : "0px 2px 5px 0px light-dark(rgba(28, 32, 36, 0.03), rgba(0, 0, 0, 0.00))" })},
jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",css:({ ["gap"] : "1rem" }),direction:"column",gap:"3"},
jsx(
RadixThemesText,
{as:"p",css:({ ["fontSize"] : "1.5rem", ["fontWeight"] : "600", ["lineHeight"] : "1.25rem", ["letterSpacing"] : "-0.0375rem" })},
"This app is paused"
,),jsx(
RadixThemesFlex,
{align:"start",className:"rx-Stack",css:({ ["gap"] : "0.625rem", ["borderRadius"] : "0.75rem", ["borderWidth"] : "1px", ["borderColor"] : "var(--amber-5)", ["backgroundColor"] : "var(--amber-3)", ["padding"] : "0.625rem" }),direction:"row",gap:"3"},
jsx(
"svg",
{css:({ ["viewBox"] : "0 0 16 16", ["fill"] : "none", ["marginTop"] : "0.125rem", ["flexShrink"] : "0" }),height:"16",width:"16",xmlns:"http://www.w3.org/2000/svg"},
jsx("path",{css:({ ["fillRule"] : "evenodd", ["clipRule"] : "evenodd", ["fill"] : "var(--amber-11)" }),d:"M6.90816 1.34341C7.61776 1.10786 8.38256 1.10786 9.09216 1.34341C9.7989 1.57799 10.3538 2.13435 10.9112 2.91605C11.4668 3.69515 12.0807 4.78145 12.872 6.18175L12.9031 6.23672C13.6946 7.63721 14.3085 8.72348 14.6911 9.60441C15.0755 10.4896 15.267 11.2539 15.1142 11.9881C14.9604 12.7275 14.5811 13.3997 14.0287 13.9079C13.4776 14.4147 12.7273 14.6286 11.7826 14.7313C10.8432 14.8334 9.6143 14.8334 8.0327 14.8334H7.9677C6.38604 14.8334 5.15719 14.8334 4.21778 14.7313C3.27301 14.6286 2.52269 14.4147 1.97164 13.9079C1.41924 13.3997 1.03995 12.7275 0.88613 11.9881C0.733363 11.2539 0.92483 10.4896 1.30926 9.60441C1.69184 8.72348 2.30573 7.63721 3.09722 6.23671L3.12828 6.18175C3.91964 4.78146 4.53355 3.69515 5.08914 2.91605C5.64658 2.13435 6.20146 1.57799 6.90816 1.34341ZM7.3335 11.3334C7.3335 10.9652 7.63063 10.6667 7.99716 10.6667H8.00316C8.3697 10.6667 8.66683 10.9652 8.66683 11.3334C8.66683 11.7016 8.3697 12.0001 8.00316 12.0001H7.99716C7.63063 12.0001 7.3335 11.7016 7.3335 11.3334ZM7.3335 8.66675C7.3335 9.03495 7.63196 9.33341 8.00016 9.33341C8.36836 9.33341 8.66683 9.03495 8.66683 8.66675V6.00008C8.66683 5.63189 8.36836 5.33341 8.00016 5.33341C7.63196 5.33341 7.3335 5.63189 7.3335 6.00008V8.66675Z"},)
,),jsx(
RadixThemesText,
{as:"p",css:({ ["fontSize"] : "0.875rem", ["fontWeight"] : "500", ["lineHeight"] : "1.25rem", ["letterSpacing"] : "-0.01094rem", ["color"] : "var(--amber-11)" })},
"If you are the owner of this app, visit "
,jsx(
RadixThemesLink,
{asChild:true,css:({ ["color"] : "var(--amber-11)", ["&:hover"] : ({ ["color"] : "var(--amber-11)", ["textDecorationColor"] : "var(--amber-11)" }), ["textDecorationColor"] : "var(--amber-10)", ["fontWeight"] : "600" }),target:(true ? "_blank" : ""),underline:"always"},
jsx(
NextLink,
{href:"https://cloud.reflex.dev/",passHref:true},
"Reflex Cloud"
,),)," for more information on how to resume your app."
,),),jsx(
RadixThemesLink,
{asChild:true,css:({ ["width"] : "100%", ["&:hover"] : ({ ["color"] : "var(--accent-8)" }) }),target:(true ? "_blank" : ""),underline:"none"},
jsx(
NextLink,
{href:"https://cloud.reflex.dev/",passHref:true},
jsx(
"button",
{css:({ ["color"] : "rgba(252, 252, 253, 1)", ["fontSize"] : "0.875rem", ["fontWeight"] : "600", ["lineHeight"] : "1.25rem", ["letterSpacing"] : "-0.01094rem", ["height"] : "2.5rem", ["padding"] : "0rem 0.75rem", ["width"] : "100%", ["borderRadius"] : "0.75rem", ["background"] : "linear-gradient(180deg, var(--violet-9) 0%, var(--violet-10) 100%)", ["&:hover"] : ({ ["background"] : "linear-gradient(180deg, var(--violet-10) 0%, var(--violet-10) 100%)" }) })},
"Resume app"
,),),),),),),)) : (jsx(Fragment,{},)
)),),),)
      )

})
